import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor
{
    /**
     * Constructor
     */
    constructor(private _authService: AuthService,
                private _router: Router
    )
    {
    }

    /**
     * Intercept
     *
     * @param req
     * @param next
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
    {   
        // Clone the request object
        let newReq = req.clone();
        // Request
        if ( this._authService.accessToken && !AuthUtils.isTokenExpired(this._authService.accessToken) )
        {
            newReq = req.clone({
                headers: req.headers.set('Authorization', 'Bearer ' + this._authService.accessToken)
            });
        }
        
        // Response
        return next.handle(newReq).pipe(            
            catchError((error) => {
                console.log('ERRRORRRRRR INTERCEPTOR');        
                // Catch "401 Unauthorized" responses
                if ( error instanceof HttpErrorResponse && error.status === 401 && this._authService.accessToken)
                {

                    // Sign out
                    this._authService.closeSession();
                    //this._authService.signOut();
                    this._router.navigate(['/sign-in']);
                    // Reload the app
                    //location.reload();
                }

                /**if ( error instanceof HttpErrorResponse && error.status === 500 && this._authService.accessToken)
                {
                    // Sign out
                    this._authService.signOut();

                    // Reload the app
                    location.reload();

                }**/

                return throwError(error);
            })
        );
    }
}
